// Name only the clicked card's photo when leaving the page, so it can morph
// into the product page's main image (cross-document view transitions).
let lastCard = null;

document.addEventListener('click', (e) => {
  lastCard = e.target.closest?.('.product-card') ?? null;
});

addEventListener('pageswap', (e) => {
  if (!e.viewTransition || !lastCard) return;
  lastCard.querySelector('.product-card__media')
    ?.style.setProperty('view-transition-name', 'product-media');
});

// Back/forward cache restores the old page as-is; clear the name so the next
// click doesn't collide with a stale one.
addEventListener('pageshow', (e) => {
  if (!e.persisted) return;
  document.querySelectorAll('.product-card__media')
    .forEach((m) => m.style.removeProperty('view-transition-name'));
});
